import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import { withTranslation, useTranslation } from 'react-i18next'

import { SignupStep } from './components/SignupStep'
import { SuccessStep } from './components/SuccessStep'

import { Email } from './components/steps/Email'
import { ConfirmEmail } from './components/steps/ConfirmEmail'
import Password from './components/steps/Password'
import { ProfileEdition } from './components/steps/ProfileEdition'
import Information from './components/steps/Information'
import { Interest } from './components/steps/Interest'
import Invitation from './components/steps/Invitation'

import PageContainer from 'srcReact/PageContainer/PageContainer'

import datasAccordions from './datasAccordions'
import queryString from 'query-string'
import styles from './styles.module.scss'
import { isEmpty } from 'srcReact/helpers/validator'
import TermsCondition from './components/steps/TermsCondition'

const SignupPage = ({ sendActivationCode, user, newEmail, email }) => {
  const { t } = useTranslation()
  const accordion = datasAccordions(t)

  const [datas, setDatas] = useState([])
  const [formState, setFormState] = useState({
    email: '',
    confirmEmail: '',
    workplace_invitations: [],
    organizations: [],
    workplaceInvitationsSelected: '',
    agreeMixrTerms: false,
    codeConfirmationEmail: '',
    skipConfirmationEmail: false,
    password: '',
    confirmPassword: '',
    profilePicturePath: '',
    profilePictureId: '',
    firstName: '',
    lastName: '',
    preferred_pronoun: null,
    personalized_pronoun: ['', ''],
    is_public: false,
    gender: null,
    dayBirth: null,
    monthBirth: {},
    yearBirth: null,
    interests: [],
    selectedInterests: [],
    fromSuccessStep: false
  })

  useEffect(() => {
    let queryStringObj = queryString.parse(location.search)
    let showRetypeEmail = false
    if (queryStringObj && queryStringObj.step) {
      if (queryStringObj.step === 'email') {
        showRetypeEmail = true
        setCurrentStep(queryStringObj.step)
        if (email) {
          setFormState({ ...formState, email: email, orgId: queryStringObj.orgid })
        }
      } else if (queryStringObj.step === 'terms') {
        setCurrentStep(queryStringObj.step)
        setFormState({
          ...formState,
          email: localStorage.getItem('ssoEmail'),
          orgId: localStorage.getItem('ssoOrgId'),
          fromSSO: 1,
          password: queryStringObj.sso_key,
          confirmPassword: queryStringObj.sso_key
        })
        localStorage.removeItem('ssoEmail')
      }
    }

    setDatas({
      email: {
        title: showRetypeEmail ? t('signup.confirmEmail.title') : t('signup.email.title'),
        rightTitle: t('signup.email.rightTitle'),
        description: t('signup.email.description'),
        component: Email,
        accordionDatas: accordion.email
      },
      confirmEmail: {
        title: t('signup.confirmEmail.title'),
        rightTitle: t('signup.confirmEmail.rightTitle'),
        description: t('signup.confirmEmail.description'),
        component: ConfirmEmail,
        accordionDatas: [
          {
            title: t('signup.confirmEmail.accordionDatas.title_1'),
            description: (
              <p>
                {t('signup.confirmEmail.accordionDatas.description_1')}{' '}
                <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleSendVerificationCode}>
                  {t('signup.confirmEmail.accordionDatas.click_here')}
                </span>{' '}
                {t('signup.confirmEmail.accordionDatas.description_1_2')}
              </p>
            ),
            descriptionHTML: true
          },
          {
            title: t('signup.confirmEmail.accordionDatas.title_2'),
            description: t(`signup.confirmEmail.accordionDatas.description_2`)
          }
        ]
      },
      password: {
        title: t('signup.password.title'),
        rightTitle: t('signup.password.rightTitle'),
        description: t('signup.password.description'),
        component: Password,
        accordionInvisible: true,
        accordionDatas: accordion.profileEdition
      },
      terms: {
        title: t('signup.termsCondition.title'),
        component: TermsCondition,
        leftImage: '/images/SSO-image.png'
      },
      profileEdition: {
        title: t('signup.profileEdition.title'),
        rightTitle: t('signup.password.rightTitle'),
        description: t('signup.profileEdition.description'),
        component: ProfileEdition,
        accordionDatas: accordion.profileEdition
      },
      information: {
        title: t('signup.information.title'),
        rightTitle: t('signup.information.rightTitle'),
        description: t('signup.information.description'),
        component: Information,
        accordionDatas: accordion.information
      },
      interest: {
        title: t('signup.interest.title'),
        rightTitle: t('signup.interest.rightTitle'),
        description: t('signup.interest.description'),
        component: Interest,
        accordionDatas: accordion.interests
      },
      invitation: {
        title: t('signup.invitation.title'),
        rightTitle: t('signup.invitation.rightTitle'),
        description: t('signup.invitation.description'),
        component: Invitation,
        accordionDatas: accordion.invitations
      }
    })
  }, [])

  useEffect(() => {
    if (formState.fromSuccessStep) {
      setDatas({
        ...datas,
        email: {
          ...datas.email,
          title: t('signup.email.title')
        }
      })
    }
  }, [formState.fromSuccessStep])

  useEffect(() => {
    if (!isEmpty(user)) {
      window.location = `${location.protocol}//${location.hostname}`
    }
  }, [user])

  const handleSendVerificationCode = () => {
    if (newEmail) {
      sendActivationCode(newEmail, true)
      setFormState({ ...formState, codeConfirmationEmail: '' })
    }
  }

  const [step, setStep] = useState(null)
  const [currentStep, setCurrentStep] = useState('email')
  const [previousStep, setPreviousStep] = useState([])
  const [newAccountDatas, setNewAccountDatas] = useState({})
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (datas) {
      setStep(datas.email)
    }
  }, [datas])

  useEffect(() => {
    if (datas && currentStep === 'terms') {
      setStep(datas.terms)
    }
  }, [currentStep, datas])

  useEffect(() => {
    const timer = setTimeout(() => {
      const isAndroid = /(android)/i.test(navigator.userAgent)
      if (isAndroid) {
        let viewheight = window.innerHeight
        let viewwidth = window.innerWidth
        let viewport = document.querySelector('meta[name=viewport]')
        viewport.setAttribute('content', 'height=' + viewheight + 'px, width=' + viewwidth + 'px, initial-scale=1.0')
      }
    }, 300)
    return () => clearTimeout(timer)
  }, [])

  const updateStep = (step) => {
    setStep(datas[step])
    setCurrentStep(step)
  }

  const goToPreviousStep = () => {
    const [previousStepName] = previousStep.slice(-1)
    const newPreviousSteps = previousStep.slice(0, -1)
    setPreviousStep(newPreviousSteps)
    updateStep(previousStepName)
  }

  return (
    <PageContainer
      pageTitle={t('meta.register.title')}
      pageDescription={t('meta.register.description')}
      pageKeywords={t('meta.register.keywords')}
      pageClassName={styles.signup}
      withFooter={false}
      isPlainBanner={true}>
      {success ? (
        <SuccessStep
          formState={formState}
          newAccountDatas={newAccountDatas}
          setSuccess={setSuccess}
          updateStep={updateStep}
          setPreviousStep={setPreviousStep}
          setFormState={setFormState}
        />
      ) : step ? (
        <SignupStep
          title={step.title}
          currentStep={currentStep}
          rightTitle={step.rightTitle}
          leftImage={step.leftImage}
          description={step.description}
          Component={step.component}
          accordionInvisible={step.accordionInvisible}
          accordionDatas={step.accordionDatas}
          setSuccess={setSuccess}
          updateStep={updateStep}
          previousStep={previousStep}
          setPreviousStep={setPreviousStep}
          goToPreviousStep={goToPreviousStep}
          formState={formState}
          setFormState={setFormState}
          setNewAccountDatas={setNewAccountDatas}
        />
      ) : null}
    </PageContainer>
  )
}

export default SignupPage

function mapStateToProps(state) {
  const {
    login: { user, email },
    authentication: { newEmail }
  } = state
  return { user, newEmail, email }
}

const actionCreators = {
  sendActivationCode: authenticationActions.sendActivationCode
}

const ExtendedComponent = withTranslation('common')(SignupPage)

const connectedSignupPage = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedSignupPage as SignupPage }
